export const BUTTON_VARIANT_M = 'm';
export const BUTTON_VARIANT_S = 's';
export const BUTTON_VARIANT_OUTLINE = 'outline-solid';
export const BUTTON_VARIANT_CLEAN = 'clean';
export const BUTTON_VARIANT_FILL = 'fill';
export const BUTTON_VARIANT_CTA = 'cta';
export const BUTTON_VARIANT_FILTER = 'filter';
